import * as React from "react";
import { TriangleAlert, Box, Clock, ShieldCheck, Truck } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const faqData = [{
  id: "item-1",
  question: "Jak często należy płukać instalację CO?",
  answer: "Zaleca się płukanie instalacji co 5-10 lat lub gdy zauważysz, że grzejniki są zimne na dole, a rachunki za gaz rosną. Regularny serwis przywraca pełną sprawność cieplną całego systemu i skutecznie chroni kocioł przed kosztownymi awariami.",
  icon: <Clock className="size-5 text-primary" />
}, {
  id: "item-2",
  question: "Czy czyszczenie chemiczne jest bezpieczne?",
  answer: "Stosujemy wyłącznie certyfikowane środki chemiczne i kontrolowane ciśnienie, co jest w pełni bezpieczne dla instalacji miedzianych, stalowych oraz PEX. Proces usuwa jedynie nagromadzone osady i kamień, nie naruszając struktury samych przewodów.",
  icon: <ShieldCheck className="size-5 text-primary" />
}, {
  id: "item-3",
  question: "Ile trwa usługa i czy wymaga kucia ścian?",
  answer: "Standardowe płukanie domu jednorodzinnego trwa od 4 do 7 godzin. Cały proces jest bezinwazyjny – podpinamy się pod istniejące przyłącza przy kotle lub rozdzielaczu, więc nie ma potrzeby kucia ścian czy demontażu podłóg w budynku.",
  icon: <Truck className="size-5 text-primary" />
}];
export default function SzybkieTerminyRealizacji() {
  return <section data-section-id="17447" id="częste-pytania-o-płukanie" className="bg-background text-foreground py-20 px-4 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.05] pointer-events-none" />
      
      {}
      <div className="absolute top-0 left-0 w-32 h-32 border-l-2 border-t-2 border-primary/20 rounded-tl-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-32 h-32 border-r-2 border-b-2 border-primary/20 rounded-br-3xl pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12 space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-mono tracking-wider uppercase">
            <Box className="size-3" />
            <span>Centrum Obsługi Klienta Hydroflush</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight font-sans">
            Częste Pytania o <span className="text-primary">Płukanie</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">Dowiedz się więcej o procesie czyszczenia instalacji CO. Zadbaj o wydajność swojego ogrzewania i obniż rachunki już dziś.</p>
        </div>

        <div className="grid gap-8">
          <div className="bg-card/80 backdrop-blur-sm border border-border/50 rounded-xl p-6 shadow-xl">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, i) => <AccordionItem key={item.id} value={item.id} className="border-b-border/50 last:border-0 px-2" data-index={i}>
                  <AccordionTrigger className="hover:no-underline hover:bg-accent/50 px-4 rounded-lg transition-colors group">
                    <div className="flex items-center gap-4 text-left">
                      <div className="bg-primary/10 p-2 rounded-md group-hover:bg-primary/20 transition-colors">
                        {item.icon}
                      </div>
                      <span className="font-bold text-lg tracking-tight group-hover:text-primary transition-colors font-sans">
                        {item.question}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pl-[4.5rem] text-muted-foreground leading-relaxed text-base font-sans">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          <div className="mt-4">
            <Alert className="border-primary/50 bg-primary/5 text-foreground shadow-lg relative overflow-hidden">
              <div className="absolute inset-0 bg-[repeating-linear-gradient(45deg,transparent,transparent_10px,var(--color-primary)_10px,var(--color-primary)_11px)] opacity-[0.03] pointer-events-none" />
              <TriangleAlert className="size-5 text-primary animate-pulse" />
              <div className="ml-2">
                <AlertTitle className="text-primary font-bold tracking-wide uppercase flex items-center gap-2 font-sans">
                  Status: Dostępne Terminy
                </AlertTitle>
                <AlertDescription className="mt-1 font-medium flex flex-col sm:flex-row sm:items-center justify-between gap-4 font-sans">
                  <span>
                    Ekspresowe płukanie instalacji dostępne w Pszczynie i okolicach 
                    Przywróć ciepło w swoim domu przed sezonem.
                  </span>
                  <Button asChild size="sm" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold shadow-md whitespace-nowrap shrink-0 rounded-lg">
                    <Link to="/ContactPage">
                      Zamów Serwis 24/7
                    </Link>
                  </Button>
                </AlertDescription>
              </div>
            </Alert>
          </div>
        </div>
      </div>
    </section>;
}